<template>
  <el-dialog
    title="产品批量出库"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="5%"
    :close-on-click-modal="false"
  >
    <div class="border-style">出库信息</div>
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="产品型号" prop="DciProductModelID">
            <select2
              style="width: 100%"
              labelName="NameNumber"
              v-model="item.DciProductModelID"
              url="dci/model/product/list?order=name"
              :clearable="false"
              placeholder="请选择产品型号"
              no-data-text="没有产品型号"
              :urlParams="{
                where: {},
              }"
              q="NameNumber:like"
              :qinwhere="true"
              :queryOne="false"
            ></select2>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="出库日期" prop="StockoutAt">
            <el-date-picker
              v-model="item.StockoutAt"
              style="width: 100%"
              type="date"
              placeholder="请选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="质保开始日期" prop="QualityStartAt">
            <el-date-picker
              v-model="item.QualityStartAt"
              style="width: 100%"
              type="date"
              placeholder="请选择日期"
              @change="changeDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="文件系统版本" prop="DciPvProductVersionID">
            <el-select
              v-model="item.DciPvProductVersionID"
              filterable
              default-first-option
              placeholder="请选择文件系统版本"
              style="width: 100%"
            >
              <el-option
                v-for="Pv in pvList"
                :value="Pv.ID"
                :label="Pv.PvName"
                :key="Pv.ID"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="质保结束日期" prop="QualityEndAt">
            <el-date-picker
              v-model="item.QualityEndAt"
              style="width: 100%"
              type="date"
              placeholder="请选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col>
          <el-form-item label="客户名称" prop="ClientName">
            <el-select
              v-model="item.ClientName"
              filterable
              allow-create
              default-first-option
              clearable
              placeholder="请选择或输入客户"
              style="width: 100%"
            >
              <el-option
                v-for="client in clientList"
                :key="client"
                :label="client"
                :value="client"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="标签" prop="Tags">
            <el-select
              v-model="item.Tags"
              :multiple-limit="6"
              multiple
              filterable
              allow-create
              default-first-option
              placeholder="请选择或创建标签"
              style="width: 100%"
            >
              <el-option
                v-for="(tag, index) in tagList"
                :key="index"
                :label="tag"
                :value="tag"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同编号" prop="ContractNos">
            <el-select
              v-model="item.ContractNos"
              multiple
              filterable
              default-first-option
              clearable
              placeholder="请选择或输入合同编号"
              style="width: 100%"
            >
              <el-option
                v-for="contract in contractList"
                :key="contract"
                :label="contract"
                :value="contract"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="出库单号" prop="CheckoutNo">
            <el-input
              v-model.trim="item.CheckoutNo"
              placeholder="请输入出库单号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出库经办人" prop="Operator">
            <el-input
              v-model.trim="item.Operator"
              placeholder="请输入经办人"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="领用部门" prop="RecipientDeptID">
            <select2
              style="width: 100%"
              v-model="item.RecipientDeptID"
              url="department"
              :clearable="false"
              placeholder="请选择部门"
              no-data-text="没有部门"
              :urlParams="{
                where: {},
              }"
              q="Name:like"
              :qinwhere="true"
              :queryOne="false"
            ></select2>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="领用人" prop="Recipient">
            <el-input
              v-model.trim="item.Recipient"
              placeholder="请输入领用人"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="出库备注" prop="StockoutReason">
        <el-input
          v-model.trim="item.StockoutReason"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入出库备注"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="border-style">相关产品</div>
    <div class="toolbar">
      <el-button
        type="primary"
        @click="onChooseProductsClick"
        :disabled="!item.DciProductModelID"
      >
        <i class="fas fa-plus"></i> 选择产品
      </el-button>
    </div>
    <el-table :data="productList" v-loading="loading">
      <el-table-column prop="DciProductModel.Name" label="产品型号名称" />
      <el-table-column prop="DciProductModel.Number" label="产品型号" />
      <el-table-column prop="SN" label="产品SN">
        <template slot-scope="{ row }">
          <el-tag>
            {{ row.SN }}
          </el-tag>
          <el-tag type="success" v-if="row.Remark">
            {{ row.Remark }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="80" label="操作">
        <template slot-scope="scope">
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>

    <el-dialog
      title="选择产品"
      :visible.sync="provisible"
      append-to-body
      :close-on-click-modal="false"
      @close="closeProduct()"
      width="40%"
      top="5vh"
    >
      <div class="top">
        <div class="left">
          <el-button type="success" @click="onChooseProducts">
            <i class="far fa-fw fa-save" aria-hidden="true"></i> 选 择
          </el-button>
        </div>
        <div class="right">
          <el-input
            v-model.trim="former['SN:like']"
            placeholder="输入SN"
            @keydown.enter.native="onProductSubmitQuery"
            style="width: 200px"
          >
          </el-input
          >&nbsp;
          <el-button type="primary" @click="onProductSubmitQuery">
            <i class="fas fa-fw fa-search"></i>
          </el-button>
        </div>
      </div>

      <el-table
        :data="itemList"
        v-loading="loading"
        @selection-change="onSelectChanged"
        :row-key="getRowKey"
        ref="tableProducts"
      >
        <el-table-column
          type="selection"
          width="55"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column prop="DciProductModel.Name" label="产品型号名称" />
        <el-table-column prop="DciProductModel.Number" label="产品型号" />
        <el-table-column prop="SN" label="产品SN">
          <template slot-scope="{ row }">
            <el-tag>
              {{ row.SN }}
            </el-tag>
            <el-tag type="success" v-if="row.Remark">
              {{ row.Remark }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="StatusName" label="状态" width="80" /> -->
      </el-table>
      <div class="clearfix mar-top-10">
        <el-pagination
          class="pull-right"
          @current-change="onProductChangePage"
          layout="total, prev, pager, next"
          :total="productPager.total"
          :current-page="productPager.page"
          :page-size="productPager.size"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: {},
      loading: false,
      rules: {
        DciProductModelID: [
          { required: true, message: "产品型号不能为空", trigger: "blur" },
        ],
        StockoutAt: [
          { required: true, message: "出库日期不能为空", trigger: "blur" },
        ],
        DciPvProductVersionID: [
          { required: true, message: "文件系统版本不能为空", trigger: "blur" },
        ],
        QualityStartAt: [
          { required: true, message: "质保开始日期不能为空", trigger: "blur" },
        ],
        QualityEndAt: [
          { required: true, message: "质保结束日期不能为空", trigger: "blur" },
        ],
        CheckoutNo: [
          { required: true, message: "出库单号不能为空", trigger: "blur" },
        ],
        ClientName: [
          { required: true, message: "客户名称不能为空", trigger: "blur" },
        ],
        ContractNos: [
          { required: true, message: "合同编号不能为空", trigger: "blur" },
        ],
        // Operator: [
        //   { required: true, message: '出库经办人不能为空', trigger: 'blur' },
        // ],
        RecipientDeptID: [
          { required: true, message: "领用部门不能为空", trigger: "blur" },
        ],
        Recipient: [
          { required: true, message: "领用人不能为空", trigger: "blur" },
        ],
        StockoutReason: [{ max: 64000, message: "内容过多", trigger: "blur" }],
      },
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
      submitting: false,
      tagList: [], //标签
      clientList: [], //客户
      contractList: [], //合同
      pvList: [], //文件系统版本
      productList: [], //相关产品

      //======弹框--选择产品==========
      //查询功能
      former: {
        DciProductModelID: "",
        "SN:like": "",
      },
      itemList: [],
      loading: false,
      productPager: {
        total: 0,
        page: 1,
        size: 10,
      },
      provisible: false,
      options: [], //弹框选择的产品
      currentProducts: [], //下拉框绑定值
    };
  },
  watch: {
    "item.DciProductModelID": {
      handler() {
        if (this.item.DciProductModelID) {
          var id = this.item.DciProductModelID;
          this.item = this.getEmptyItem();
          this.item.DciProductModelID = id;
          this.getPVList();
        }
      },
    },
  },
  methods: {
    onOpen() {
      this.item = this.getEmptyItem();

      this.getTagList();
      this.getClientList();
      this.getContractList();
      // this.getPVList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.productList = [];
      this.$refs.itemform.resetFields();
    },
    getTagList() {
      this.$axios
        .get("dci/product/stock-tags")
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getClientList() {
      this.$axios
        .get("dci/product/stock-clients")
        .then((response) => {
          this.clientList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getContractList() {
      this.$axios
        .get("dci/product/stock-contracts")
        .then((response) => {
          this.contractList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    //绑定文件系统版本
    getPVList() {
      //根据产品型号自动绑定默认版本
      this.item.DciPvProductVersionID = null;
      this.$axios
        .get("dci/pv/productversion/list", {
          params: {
            dciProductModelID: this.item.DciProductModelID, //产品型号id
            order: ["-pv_name"],
            total: 0,
            page: 1,
            size: -1,
          },
        })
        .then((response) => {
          for (const pv of response.data.data) {
            if (pv.IsDefault) {
              this.item.DciPvProductVersionID = pv.ID;
              pv.PvName = pv.PvName + "【默认】";
            }
          }
          this.pvList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getEmptyItem() {
      this.productList = [];
      const date = new Date();
      // this.item.StockoutAt = date;
      // this.item.QualityStartAt = date;
      // this.item.QualityEndAt = new Date(
      //   date.getTime() + 3600 * 1000 * 24 * 365
      // );
      // this.item.Operator = this.$store.state.Auth.user.Name;

      return {
        DciProductModelID: null,
        DciPvProductVersionID: null,
        Tags: [],
        ClientName: "",
        CheckoutNo: "",
        ContractNos: [],
        Recipient: "",
        StockoutReason: "",
        StockoutAt: date,
        QualityStartAt: date,
        QualityEndAt: new Date(date.getTime() + 3600 * 1000 * 24 * 365),
        Operator: this.$store.state.Auth.user.Name,
      };
    },
    changeDate(val) {
      //质保开始日期修改，质保结束日期也自动修改,默认质保开始日期开始一年
      if (val) {
        const date = this.item.QualityStartAt;
        this.item.QualityEndAt = new Date(
          date.getTime() + 3600 * 1000 * 24 * 365
        );
      } else {
        this.item.QualityEndAt = val;
      }
    },
    //删除产品
    onDeleteItem(row) {
      // this.$confirm("确定要删除该信息吗？", "提示")
      //   .then(() => {
      for (let index = 0; index < this.productList.length; index++) {
        const element = this.productList[index];
        if (element.ID === row.ID) {
          this.productList.splice(index, 1);
          break;
        }
      }
      // })
      // .catch(({ response }) => {
      //   this.$sys.alarmResponse(response);
      // });
    },
    //确认出库
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.productList.length == 0) {
          this.$message({
            type: "warning",
            message: "请选择出库产品",
            duration: 1500,
          });
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        var ids = [];
        this.productList.forEach((item) => {
          ids.push(item.ID);
        });
        itemData.ProductIDs = ids;
        // 保存的操作
        this.$axios
          .request({
            url: `dci/product/stock-out/batch`,
            method: "POST",
            data: itemData,
          })
          .then(() => {
            this.$message.success("操作成功");
            this.submitting = false;
            this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
            this.onClose();
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },

    //===============弹框-选择产品==========================
    //点击选择产品按钮
    onChooseProductsClick() {
      this.getProductItemList();
      this.options = [];
      this.provisible = true;
    },

    //点击查询产品列表
    onProductSubmitQuery() {
      this.productPager.page = 1;
      this.getProductItemList();
    },

    onProductChangePage(page) {
      this.productPager.page = page;
      this.getProductItemList();
    },

    //获取产品列表
    getProductItemList() {
      this.loading = true;
      this.$axios
        .get("dci/product/stock-list/list", {
          params: {
            where: {
              DciProductModelID: this.item.DciProductModelID,
              "SN:like": this.former["SN:like"],
            },
            statusIn: "1", //进显示入库状态的产品
            ...this.productPager,
            with: [
              "DciProductModel",
              "DciAccessories.DciAccessoryModel",
              "DciPvProductVersion",
            ],
            order: ["-stockin_at", "-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.productPager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //选择产品
    onSelectChanged(options) {
      this.options = options;
    },

    //弹框选择产品
    onChooseProducts() {
      let obj1;
      let obj2;
      for (obj1 of this.options) {
        let flag = true;
        for (obj2 of this.productList) {
          if (obj1.ID === obj2.ID) {
            flag = false;
            break;
          }
        }
        if (flag) {
          this.productList.push(obj1);
        }
      }

      this.closeProduct();
    },
    getRowKey(row) {
      return row.ID;
    },
    closeProduct() {
      this.options = [];
      this.$refs.tableProducts.clearSelection();
      this.former.DciProductModelID = "";
      this.former["SN:like"] = "";
      this.provisible = false;
    },
  },
};
</script>
<style scoped>
.el-divider--horizontal {
  margin: 0px 0 12px 0;
}
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}
.dialogDiv {
  height: 450px;
  overflow: auto;
  padding-left: 10px;
  padding-right: 10px;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 10px 20px 10px 20px;
  margin: -30px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 20%;
  background-color: #f5f7fa;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
  background-color: #f5f7fa;
}
</style>
